import * as React from "react";
import {
  Accordion,
  AccordionHeader,
  AccordionItem,
  AccordionPanel,
  Divider,
  Link,
  makeStyles,
} from "@fluentui/react-components";
import CitationsList from "../tabs/home-tab/citations-list";
import type { CitationCollection } from "@/types";

type CardCitationsProps = {
  citations: CitationCollection;
  showDivider: boolean;
};

export const CardCitations: React.FC<CardCitationsProps> = ({ citations, showDivider }) => {
  const styles = useStyles();

  return (
    <>
      {showDivider && <Divider className={styles.divider} />}
      <CitationsList {...citations} />
      {!!citations.reportCitations?.length && (
        <Accordion multiple collapsible>
          {citations.reportCitations.map((citation, index) => (
            <AccordionItem key={citation.id} value={citation.id}>
              <AccordionHeader>
                [{index + 1}] {citation.title} · {citation.period}
              </AccordionHeader>
              <AccordionPanel>
                <p className={styles.quote}>{citation.quote}</p>
                {citation.sheet && (
                  <p className={styles.quote}>
                    {citation.sheet}
                    {citation.cell ? `!${citation.cell}` : ""}
                  </p>
                )}
                {citation.sourceUrl && (
                  <Link
                    href={citation.sourceUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className={styles.sourceLink}
                    aria-label={`Open source report: ${citation.title}, ${citation.period}`}
                  >
                    Open source report
                  </Link>
                )}
              </AccordionPanel>
            </AccordionItem>
          ))}
        </Accordion>
      )}
    </>
  );
};

const useStyles = makeStyles({
  quote: { fontSize: "12px", overflowWrap: "anywhere" },
  sourceLink: { display: "inline-block", fontSize: "12px", marginBottom: "8px" },
  divider: {
    height: "48px",
  },
});
